import { NodoFormulario, NodoFormulario_lite } from './NodoFormulario';
import { BeaconPlano } from 'interiores-mapa/dist/beaconPlano';
import { SeccionFormulario } from './SeccionFormulario';
import { EspacioFormulario } from './EspacioFormulario';
import { ContenidoPlano } from 'interiores-mapa';
import { Constantes } from './constantes';
import { environment } from '../../environments/environment';

export class AvisoCiudadanoFormulario {

	Id: string;
	Titulo: string;
	Cuerpo: string;
	Contenido: string;
	FechaCreacion: Date;
	FechaInicio: Date;
	FechaFin: Date;
	EsParaVisitantesActuales: boolean;
	numeroDestinatarios: number;
	numeroEnvios: number;
	TiempoReenvioMinutos: number;

	Tipo: number; // 0.- Instantanea, 1.- Programada
	AccionDesencadenante: number; // 0.- Entrando, 1.- Saliendo

	X: number;
	Y: number;
	Latitud: number;
	Longitud: number;

	alaPertenencia: string;

	IconoRepresentacion: string;

	nodos: NodoFormulario_lite[];
	secciones: SeccionFormulario[];
	espacios:  EspacioFormulario[];

	foto: string;
    contenidoAsociado: string;

	MostrarEdicion: boolean;
	repetir;
	alEntrar;
	alSalir;    // 0.- Entrando, 1.- Saliendo
	estan;
	visitaron;
	exploraron;
	tienenApp;

	Imagen: any; // FotoBlob;

	// Objeto de Breeze
	ENTIDAD: any;
	SECCIONES: any[];
	NODOS: any[];
	ESPACIOS: any[];
	CONTENID: any;

	AVISO_PLANO: ContenidoPlano = ContenidoPlano.createInstance();

	constructor() {
		this.ENTIDAD = {};
		this.Id = '';
		this.Titulo = '';
		this.Cuerpo = '';
		this.FechaCreacion = new Date();
		this.TiempoReenvioMinutos = null;
		this.Contenido = '';
		this.FechaInicio  = null;
		this.FechaFin  = null;
		this.EsParaVisitantesActuales = true;
		this.numeroDestinatarios = 0;
		this.X = 0;
		this.Y = 0;
		this.Latitud = 0;
		this.Longitud = 0;

		this.Tipo = 0; // 0.- Instantanea, 1.- Programada
		this.AccionDesencadenante = null;
/*
            ENVIAR_AL_ENTRAR = 0,
	        ENVIAR_AL_SALIR = 1,
            ESTAN_AHORA = 2,
            VISITADO_ALGUNA_VEZ = 3,
            EXPLORADO_ALGUNA_VEZ = 4,
	        TIENEN_LA_APP = 5
*/

		this.alaPertenencia = '';

		this.nodos = [];
		this.secciones = [];
		this.espacios = [];

		this.AVISO_PLANO = ContenidoPlano.createInstance();
		this.SECCIONES = [];
		this.NODOS = [];
		this.ESPACIOS = [];

		this.IconoRepresentacion = 'assets/itsoft/IconosSVG/' + 'email.svg';

	}


	fromENTIDAD(ENTIDAD: any): AvisoCiudadanoFormulario{

		this.fromENTIDAD_LITE(ENTIDAD);

		this.numeroEnvios = ENTIDAD.ENVIOS ? ENTIDAD.ENVIOS.length : 0;
		this.numeroDestinatarios = ENTIDAD.ENVIOS ? this.unique(ENTIDAD.ENVIOS).length : 0;


		ENTIDAD.NODOS.forEach(Nodo_has_aviso => {
			if (Nodo_has_aviso.NODO) {
				this.NODOS.push(Nodo_has_aviso);
				const nodo: NodoFormulario_lite = new NodoFormulario_lite().fromENTIDAD(Nodo_has_aviso.NODO);
				this.nodos.push(nodo);

				if (Nodo_has_aviso.NODO.SECCION && Nodo_has_aviso.NODO.SECCION.ALA) {
					this.alaPertenencia = Nodo_has_aviso.NODO.SECCION.ALA.Nomobre;
				}
			}

		});

		ENTIDAD.ESPACIOS.forEach(Espacio_has_aviso => {
			if (Espacio_has_aviso.ESPACIO) {
				this.ESPACIOS.push(Espacio_has_aviso);
				const espacio: EspacioFormulario = new EspacioFormulario(Espacio_has_aviso.ESPACIO);

				if(this.espacios.find( e => e.Id === espacio.Id) === undefined){
					this.espacios.push(espacio);
				}

			}
		});

		if (ENTIDAD.FOTO && ENTIDAD.FOTO.Length > 0){
			this.foto = ENTIDAD.FOTO[0].UrlFotoExt;
		}

		if (ENTIDAD.CONTENID){
			this.contenidoAsociado = ENTIDAD.CONTENID.Titulo;
		}

		ENTIDAD.SECCIONES.forEach(seccion_has_aviso => {
			this.SECCIONES.push(seccion_has_aviso.SECCION);
			const seccion: SeccionFormulario = new SeccionFormulario().fromENTIDAD(seccion_has_aviso.SECCION);

			if(this.secciones.find( e => e.Id === seccion.Id) === undefined){
				this.secciones.push(seccion);
			}

		});

		// FOTO
		if (this.ENTIDAD.FOTO[0] !== undefined) {
			const ultima = this.ENTIDAD.FOTO.length - 1;

			if (this.ENTIDAD.FOTO[ultima] && this.ENTIDAD.FOTO[ultima].UrlFotoExt) {
				this.Imagen = this.ENTIDAD.FOTO[ultima].UrlFotoExt;
			}
			else if (this.ENTIDAD.FOTO[ultima] && this.ENTIDAD.FOTO[ultima].IdFotoExt){
				this.Imagen =  environment.urlBaseFotos + this.ENTIDAD.FOTO[ultima].IdFotoExt;
			}
		}

		return this;
	}

	fromBeaconPlano(cont: ContenidoPlano): AvisoCiudadanoFormulario{

		this.AVISO_PLANO = cont;

		if (this.AVISO_PLANO && this.AVISO_PLANO.ENTIDAD) {
			return this.fromENTIDAD(this.AVISO_PLANO.ENTIDAD);
		}

		return this;
	}


	fromENTIDAD_LITE(ENTIDAD: any): AvisoCiudadanoFormulario{
		this.ENTIDAD = ENTIDAD;
		this.Id = ENTIDAD.Id;
		this.Titulo = ENTIDAD.Titulo;
		this.Cuerpo = ENTIDAD.Cuerpo;
		this.FechaCreacion = ENTIDAD.FechaCreacion;
		this.TiempoReenvioMinutos = ENTIDAD.TiempoReenvioMinutos;
		this.Contenido = ENTIDAD.Contenido;
		this.FechaInicio  = ENTIDAD.FechaInicio;
		this.FechaFin  = ENTIDAD.FechaFin;
		this.EsParaVisitantesActuales = ENTIDAD.EsParaVisitantesActuales;
		this.numeroDestinatarios = ENTIDAD.numeroDestinatarios;
		this.X = ENTIDAD.X;
		this.Y = ENTIDAD.Y;
		this.Latitud = ENTIDAD.Latitud;
		this.Longitud = ENTIDAD.Longitud;
		this.Tipo = ENTIDAD.Tipo;
		this.AccionDesencadenante = ENTIDAD.AccionDesencadenante;

		this.alEntrar = ENTIDAD.AccionDesencadenante === Constantes.ENVIAR_AL_ENTRAR ? true : false;
		this.alSalir = ENTIDAD.AccionDesencadenante === Constantes.ENVIAR_AL_SALIR ? true : false;

		this.estan = ENTIDAD.AccionDesencadenante === Constantes.ESTAN_AHORA ? true : false;
		this.visitaron = ENTIDAD.AccionDesencadenante === Constantes.VISITADO_ALGUNA_VEZ ? true : false;
		this.exploraron = ENTIDAD.AccionDesencadenante === Constantes.EXPLORADO_ALGUNA_VEZ ? true : false;
		this.tienenApp = ENTIDAD.AccionDesencadenante === Constantes.TIENEN_LA_APP ? true : false;



		this.repetir = this.ENTIDAD.TiempoReenvioMinutos === null ? false : true;

		this.nodos = [];
		this.secciones = [];
		this.espacios = [];

		return ENTIDAD;
	}

	unique (xs) {
		const seen = {};
		return xs.filter(function(x) {
			if (seen[x.IdUsuario]){
				return;
			}
			seen[x.IdUsuario] = true;
			return x.IdUsuario;
		});
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/AvisoCiudadanoFormulario.ts